<div
    [id]="trustboxId"
    data-locale="en-GB"
    data-template-id="5419b732fbfb950b10de65e5"
    data-businessunit-id="5c1117ba393a0100015d0b82"
>
    <a
        href="https://www.trustpilot.com/review/www.proportunity.co?utm_medium={{ utmMedium }}&utm_source={{ utmSource }}"
        target="_blank"
        rel="noopener"
    >
        Trustpilot
    </a>
</div>